// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { parseJSON as fn } from "../parseJSON.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const parseJSON = convertToFP(fn, 1);

// Fallback for modularized imports:
export default parseJSON;
